import { Injectable } from '@angular/core';

/**
 * Holds a notification's deep-link target between the moment the cold-start
 * "tap" event arrives and the moment app-level default redirects (e.g. the
 * public home page routing an already-logged-in user to their dashboard)
 * would otherwise run and clobber it.
 */
@Injectable({ providedIn: 'root' })
export class PendingNotificationRedirectService {
  private pendingPage: string | null = null;

  setPendingPage(page: string): void {
    this.pendingPage = page;
  }

  consumePendingPage(): string | null {
    const page = this.pendingPage;
    this.pendingPage = null;
    return page;
  }
}
